const URL_MAINNET = "https://trustlesswallet.io";
const URL_REGTEST = "https://dev.trustlesswallet.io";
export { URL_MAINNET, URL_REGTEST };
//# sourceMappingURL=constant.js.map